export function isEnrichRuntimeStatusSupported(environmentName: string | null | undefined): boolean {
  return environmentName?.trim().toLowerCase() === 'staging';
}
